var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Divider, TextField, Typography } from "@mui/material";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useCreateAndAddExternalUserToTeam, useRetrieveTeam, } from "../ApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { useNumericParams } from "../utils/useNumericParams";
export var CreateExternalUserAndAddToTeamForm = function () {
    var navigate = useNavigate();
    var teamId = useNumericParams().id;
    var _a = useRetrieveTeam({ id: teamId }), useRetrieveTeamIsLoading = _a.isLoading, useRetrieveTeamError = _a.error, team = _a.data;
    var onSuccess = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var player;
        return __generator(this, function (_a) {
            player = data.data;
            navigate("/players/".concat(player.id, "/"));
            return [2 /*return*/];
        });
    }); };
    var createAndAddExternalUserToTeamMutation = useCreateAndAddExternalUserToTeam({
        teamId: teamId,
        onMutate: function () { },
        onSuccess: onSuccess,
        onError: function () { },
    });
    var _b = useForm({
        defaultValues: {
            firstName: "",
            lastName: "",
            squadNumber: null,
        },
    }), control = _b.control, handleSubmit = _b.handleSubmit, errors = _b.formState.errors;
    if (createAndAddExternalUserToTeamMutation.isLoading ||
        useRetrieveTeamIsLoading) {
        return _jsx(Loading, {});
    }
    if (!team || useRetrieveTeamError) {
        return _jsx(ErrorView, { error: useRetrieveTeamError });
    }
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: !!createAndAddExternalUserToTeamMutation.isError, message: "Failed to create player. Please try again.", onClose: function () { } }), _jsx(ErrorSnackbar, { open: !!useRetrieveTeamError, message: "Failed to retrieve team. Please try again." }), _jsx(Typography, { variant: "h6", children: _jsxs("strong", { children: ["Create and Add Player to ", team.name] }) }), _jsxs(Box, { component: "form", role: "form", onSubmit: handleSubmit(function (data) {
                    createAndAddExternalUserToTeamMutation.mutate(data);
                }), noValidate: true, sx: { mt: 1 }, children: [_jsx(Typography, { variant: "h6", children: "Personal Information" }), _jsx(Divider, { style: { margin: "15px 0" } }), _jsx(Controller, { name: "firstName", control: control, rules: { required: "First Name is required" }, render: function (_a) {
                            var _b;
                            var field = _a.field;
                            return (_jsx(TextField, __assign({}, field, { margin: "normal", fullWidth: true, label: "First Name", required: true, error: !!errors.firstName, helperText: (_b = errors.firstName) === null || _b === void 0 ? void 0 : _b.message, autoFocus: true })));
                        } }), _jsx(Controller, { name: "lastName", control: control, rules: { required: "Last Name is required" }, render: function (_a) {
                            var _b;
                            var field = _a.field;
                            return (_jsx(TextField, __assign({}, field, { margin: "normal", fullWidth: true, label: "Last Name", required: true, error: !!errors.lastName, helperText: (_b = errors.lastName) === null || _b === void 0 ? void 0 : _b.message })));
                        } }), _jsx(Controller, { name: "squadNumber", control: control, rules: {
                            min: { value: 1, message: "Must be between 1 and 99" },
                            max: { value: 99, message: "Must be between 1 and 99" },
                        }, render: function (_a) {
                            var _b, _c, _d;
                            var field = _a.field;
                            return (_jsx(TextField, __assign({}, field, { value: (_b = field.value) !== null && _b !== void 0 ? _b : "", onChange: function (e) {
                                    var val = e.target.value;
                                    field.onChange(val === "" ? null : Number(val));
                                }, margin: "normal", fullWidth: true, label: "Squad Number", type: "number", error: !!errors.squadNumber, helperText: (_d = (_c = errors.squadNumber) === null || _c === void 0 ? void 0 : _c.message) !== null && _d !== void 0 ? _d : "Optional (1-99)", inputProps: { min: 1, max: 99 } })));
                        } }), _jsxs(Box, { sx: {
                            display: "flex",
                            justifyContent: "center",
                            gap: 2,
                            mt: 3,
                            mb: 2,
                        }, children: [_jsx(Button, { type: "submit", variant: "contained", color: "primary", size: "large", sx: { minWidth: 120 }, children: "Create" }), _jsx(Button, { variant: "outlined", color: "secondary", size: "large", sx: { minWidth: 120 }, onClick: function () { return navigate(-1); }, children: "Cancel" })] })] })] }));
};
